import DialogComponent from 'components/Dialog';
import React, {memo} from 'react';
import {Trans} from 'react-i18next';
import {DialogTypes} from '../../../../../../common/names';
import Button from '../../../../../../components/Button';
import FormikDatePicker from '../../../../../../components/inputs/FormikDatePicker';
import Panel from '../../../../../../components/Panel';
import i18n from '../../../../../../i18n';
import {IHoliday} from '../../../../../../types/Holiday';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import {Grid} from '@mui/material';
import {GridColDef, DataGridPro, GridValueFormatterParams} from '@mui/x-data-grid-pro';
import {formatDate} from 'common/dateUtils';
import fedHolidays from '@18f/us-federal-holidays';
import dayjs from 'dayjs';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

export const holidayColumns: GridColDef[] = [
   {field: 'name', headerName: i18n.t('Name'), flex: 200},
   {
      field: 'date',
      headerName: i18n.t('Date'),
      flex: 200,
      valueFormatter: (params: GridValueFormatterParams) => formatDate(params.value as Date),
   },
];

type AddUSHolidayDialogProps = {
   onSubmit: (values: IHoliday[]) => void;
   onClose: () => void;
   years?: number[];
   currentYear?: number;
};
const options = {shiftSaturdayHolidays: false, shiftSundayHolidays: false};

const AddUSHolidayDialog: ReactFChildrenProps<AddUSHolidayDialogProps> = memo((props) => {
   const {onSubmit, onClose} = props;
   const [selected, setSelected] = React.useState<IHoliday[]>([]);

   const [year, setYear] = React.useState<Date | null>();
   const data = React.useMemo(() => {
      let id = 0;
      const yesterday = new Date(Date.now() - 1);
      const holidays = fedHolidays
         .allForYear(dayjs(year).year(), options)
         .filter((h) => h.date > yesterday)
         .map((h) => ({...h, id: String(id++)}));
      return holidays;
   }, [year]);

   return (
      <DialogComponent maxWidth="md" header={DialogTypes.AddUSHoliday.dialogName} close={onClose}>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormikDatePicker
                  name="year"
                  label={i18n.t('Year')}
                  yearOnly
                  disablePast
                  value={year}
                  onChange={setYear}
               />
            </Grid>
         </Grid>
         <Panel name={i18n.t('Holidays')}>
            <div style={{height: 500, width: '100%'}}>
               <DataGridPro
                  density="compact"
                  rows={data}
                  columns={holidayColumns}
                  pageSize={10}
                  checkboxSelection
                  onSelectionModelChange={(selectionModel) => {
                     // console.debug(param);
                     setSelected(
                        selectionModel.map((id) => data.find((h) => h.id === id)) as IHoliday[]
                     );
                  }}
               />
            </div>
         </Panel>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <PrimaryButton type="submit" onClick={() => onSubmit(selected)}>
                  <Trans>Ok</Trans>
               </PrimaryButton>
            </Grid>
            <Grid item>
               <Button type="button" onClick={onClose}>
                  <Trans>Cancel</Trans>
               </Button>
            </Grid>
         </Grid>
      </DialogComponent>
   );
});

export default AddUSHolidayDialog;
